import axios from 'axios'
import router from '../router'
import {useAlertsStore} from "../stores/alerts.js";


const apiClient = axios.create({
    baseURL: `/api`,
    timeout: 5000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})
apiClient.interceptors.response.use(function (response) {

    return response;
}, function (error) {
    if(error.code === 'ERR_NETWORK') {
        useAlertsStore().add('danger', 'Ein unerwarteter Fehler ist passiert, bist du mit dem Internet verbunden?');
        window.scrollTo(0, 0);
        return Promise.reject();
    }
    if(error.response && error.response.status === 401 && ["login", "register"].indexOf(router.currentRoute.name) === -1) {
        router.push("/login");
        window.scrollTo(0, 0);
        return Promise.reject();
    }
    if(error.response && error.response.status === 452) {
        router.push({path: "/confirm", query: {email: error.response.data.email}})
        return Promise.reject();
    }
    if(error.response && error.response.status === 500) {
        useAlertsStore().add('danger', 'Ein interner Serverfehler ist passiert.');
        window.scrollTo(0, 0);
        return Promise.reject();
    }
    //if(error.response && error.response.data && Object.hasOwn(error.response.data, 'success') && error.response.data.success === false) {
    //    useAlertsStore().add('danger', error.response.data.message);
    //    window.scrollTo(0, 0);
    //    return Promise.reject();
    //}

    console.log("error passiert: ", error);
    return Promise.reject(error);
});
export default apiClient;